import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { appStateStore } from '@shared/stores/app-state.store';

@Pipe({
  standalone: true,
  name: 'translation',
})
export class TranslationPipe implements PipeTransform {
  private readonly translatePipe = inject(TranslatePipe);
  private readonly stateStore = inject(appStateStore);

  transform(value: any, transform?: boolean): any {
    if (value?.ua || value?.en)
      return transform ?
        this.translatePipe.transform(value[this.stateStore.language()]) :
        value[this.stateStore.language()];
    return value ? value : '';
  }
}
